'use strict';

exports.__esModule = true;
exports['default'] = invert;

var _parseToRgb = /*#__PURE__*/ _interopRequireDefault(/*#__PURE__*/ require('./parseToRgb'));

var _toColorString = /*#__PURE__*/ _interopRequireDefault(/*#__PURE__*/ require('./toColorString'));

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _extends() {
    _extends =
        Object.assign ||
        function (target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = arguments[i];
                for (var key in source) {
                    if (Object.prototype.hasOwnProperty.call(source, key)) {
                        target[key] = source[key];
                    }
                }
            }
            return target;
        };
    return _extends.apply(this, arguments);
}

/**
 * Inverts the red, green and blue values of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: invert('#CCCD64'),
 *   background: invert('rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${invert('#CCCD64')};
 *   background: ${invert('rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#33329b";
 *   background: "rgba(154,155,50,0.7)";
 * }
 */
function invert(color) {
    if (color === 'transparent') return color; // parse color string to rgb

    var value = (0, _parseToRgb['default'])(color);
    return (0, _toColorString['default'])(
        _extends({}, value, {
            red: 255 - value.red,
            green: 255 - value.green,
            blue: 255 - value.blue,
        })
    );
}

module.exports = exports.default;
